export default "__VITE_ASSET__tbs9$vLq__"